module.exports = __webpack_public_path__ + "static/media/Completed.30048de0.svg";